import { AxiosRequestConfig } from 'axios';
import { axiosClient } from '@as-react/common-utils';
import { ProductGroupFredhopperState } from '@as-react/common-types';
import { createUrl } from '../../utils/createUrl';
import { QueryApiOptions, UrlMapping } from '../../types/types';
import { campaignQueryKeys } from './campaign.queries';

const campaignEndpoints: UrlMapping<typeof campaignQueryKeys> = {
  getFredhopperCampaigns: {
    client: 'api/campaign/search?mainWebShop={mainWebshop}&locale={locale}&pageType=basket',
  },
};

export const getFredhopperCampaigns = async (
  { servicesEndpoint, isServer, defaultRequestParams }: QueryApiOptions,
  locale: string
): Promise<Array<ProductGroupFredhopperState>> => {
  const url = createUrl(servicesEndpoint, campaignEndpoints.getFredhopperCampaigns, isServer, {
    mainWebshop: defaultRequestParams.mainWebshop,
    locale,
  });

  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url,
    withCredentials: true,
  };

  const result = await axiosClient.request(axiosConfig);
  return result.data;
};
